var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.$user)?_c('TheLayout',[_c('router-view')],1):_c('TheLayoutAuth',[_c('router-view')],1),_c('notifications',{attrs:{"group":"error","duration":5000}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }